// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qxrrjpepoyubksiuxany.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF4cnJqcGVwb3l1YmtzaXV4YW55Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk4MzU2MzEsImV4cCI6MjA3NTQxMTYzMX0.ZDc0Dn6snuQ7hMlCAsLyrtqVEG-BjiTA3Nc6v9UfRzw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});